import { usePatientDocuments } from "@repo/data-store";
import { createFileRoute, Link } from "@tanstack/react-router";
import { DocumentList, DocumentRowActions, UploadDocumentButton } from "@/features/documents";

export const Route = createFileRoute("/patients/$patientId/_layout/documents/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { patientId } = Route.useParams();
  const { documents, isReady } = usePatientDocuments({ patientId });

  // An empty list is not a fact until the collection has answered. Rendering
  // the empty state before then tells the clinician there are no documents,
  // then contradicts itself a moment later.
  if (!isReady) return null;

  if (documents.length === 0) {
    return (
      <DocumentList.Empty>
        <UploadDocumentButton patientId={patientId} />
      </DocumentList.Empty>
    );
  }

  return (
    <DocumentList>
      <DocumentList.Header>
        <UploadDocumentButton patientId={patientId} />
      </DocumentList.Header>
      <DocumentList.Body>
        {documents.map((document) => (
          <DocumentList.Item
            key={document.id}
            document={document}
            renderLink={(props) => (
              <Link
                {...props}
                to="/patients/$patientId/documents/$documentId"
                params={{ patientId, documentId: document.id }}
              />
            )}
            actions={<DocumentRowActions document={document} />}
          />
        ))}
      </DocumentList.Body>
    </DocumentList>
  );
}
